import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { INoteModel } from '@apps-common/types/management/note'

export const updateNote = async (model: INoteModel): Promise<INoteModel> =>
  axios.post(`/management/note/updatenote`, model).then((res) => res?.data?.data)

type Props = {
  model: INoteModel
}

export const useManagementUpdateNote = (notify?: boolean, onSuccess?: (data: INoteModel) => void) =>
  useMutation({
    mutationKey: ['updateNote'],
    mutationFn: ({ model }: Props) => updateNote(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated note.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update note, please try again.')
      }
    },
    throwOnError: false
  })
